import { useQuery } from "@tanstack/react-query"
import { PredefinedResponsesDistributionQuery } from "../lib/predefinedResponsesDistributionQuery"

export function usePredefinedResponsesDistributionQuery(
  ...args: Parameters<typeof PredefinedResponsesDistributionQuery>
) {
  return useQuery(PredefinedResponsesDistributionQuery(...args))
}
